/* ═══════════════════════════════════════════════════════════════
   Warteschlange für Etikettenfotos

   Bilder gehören nicht ins Kellerbuch-JSON, sondern als Dateien auf
   den Server. Ohne Netz gibt es also nichts, wohin sie könnten — und
   ein verworfenes Foto ist verlorene Arbeit: Die Flasche steht dann
   nicht mehr vor der Kamera.

   Deshalb liegt ein ohne Netz aufgenommenes Foto hier zwischen, bis
   der Server wieder erreichbar ist. IndexedDB und nicht localStorage,
   weil dort Base64-Bilder das Kontingent (meist 5 MB) in wenigen
   Aufnahmen sprengen würden — und zwar dasselbe Kontingent, in dem
   auch die lokale Kopie des Kellerbuchs liegt. Ein volles
   localStorage würde also das Kellerbuch mit in Gefahr bringen.

   Bewusst ohne Fremdpaket: Es sind vier Vorgänge auf einem einzigen
   Objektspeicher.
   ═══════════════════════════════════════════════════════════════ */

const DB_NAME = "winelake";
const DB_VERSION = 1;
const LADEN = "fotowarteschlange";


/* Verbindung wird beim ersten Zugriff geöffnet und dann gehalten. */
let verbindung = null;

function db() {
  if (verbindung) return verbindung;
  verbindung = new Promise((fertig, fehler) => {
    if (typeof indexedDB === "undefined") { fehler(new Error("IndexedDB steht nicht zur Verfügung.")); return; }
    const anfrage = indexedDB.open(DB_NAME, DB_VERSION);
    anfrage.onupgradeneeded = () => {
      const d = anfrage.result;
      if (!d.objectStoreNames.contains(LADEN)) d.createObjectStore(LADEN, { keyPath: "id" });
    };
    anfrage.onsuccess = () => fertig(anfrage.result);
    anfrage.onerror = () => fehler(anfrage.error || new Error("IndexedDB konnte nicht geöffnet werden."));
    anfrage.onblocked = () => fehler(new Error("IndexedDB ist blockiert."));
  });
  /* Ein Fehlschlag darf sich nicht einbrennen — beim nächsten Versuch
     wird neu geöffnet (etwa im privaten Modus mancher Browser). */
  verbindung.catch(() => { verbindung = null; });
  return verbindung;
}


function vorgang(modus, arbeit) {
  return db().then((d) => new Promise((fertig, fehler) => {
    const t = d.transaction(LADEN, modus);
    const speicher = t.objectStore(LADEN);
    let ergebnis;
    try { ergebnis = arbeit(speicher); } catch (e) { fehler(e); return; }
    t.oncomplete = () => fertig(ergebnis && ergebnis.result !== undefined ? ergebnis.result : ergebnis);
    t.onerror = () => fehler(t.error);
    t.onabort = () => fehler(t.error || new Error("Vorgang abgebrochen."));
  }));
}


/** Ein vorbereitetes Bild einreihen. `eintrag` enthält alles, was der
    Upload später braucht: jgId, voll, thumb, breite, hoehe. */
async function einreihen(eintrag) {
  await vorgang("readwrite", (s) => s.put(eintrag));
  return eintrag;
}


/** Alle wartenden Einträge, älteste zuerst. */
async function alle() {
  const liste = await vorgang("readonly", (s) => s.getAll());
  return (liste || []).sort((a, b) => String(a.angelegt || "").localeCompare(String(b.angelegt || "")));
}


async function entfernen(id) {
  await vorgang("readwrite", (s) => s.delete(id));
}


async function holen(id) {
  return (await vorgang("readonly", (s) => s.get(id))) || null;
}


/** Anzahl wartender Bilder — für die Anzeige, darf fehlschlagen. */
async function anzahl() {
  try { return (await vorgang("readonly", (s) => s.count())) || 0; } catch (e) { return 0; }
}


/** Beim Abmelden: nichts vom vorigen Konto zurücklassen. */
async function leeren() {
  try { await vorgang("readwrite", (s) => s.clear()); } catch (e) { /* egal */ }
}


export { alle, anzahl, einreihen, entfernen, holen, leeren };
